module.exports = __webpack_public_path__ + "static/media/video-play-btn.87237319.svg";